/**
 * Договор с учреждениями на осуществление образовательной деятельности, краткое описание
 */
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { BaseModel } from '@n3/ng-api-base-kit';

export class EducationContractShort extends BaseModel {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public institution_identity: Identity; /**/
    public subject: ClassifierShort; /**/
    public group_count: number; /*Количество групп*/
    public contragent_institution: string; /*Название учреждения, с которым подписан договор*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super();

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.institution_identity = new Identity(json.institution_identity);
        this.subject = new ClassifierShort(json.subject);
        this.group_count = json.group_count || null;
        this.contragent_institution = json.contragent_institution || null;
        this._isEmpty = this.isEmpty(this);
    }
}
